/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.23",
    versionName: "0.2.0-nightly.2025.10.23",
    versionChannel: "nightly",
    buildDate: "2025-10-23T00:07:55.958Z",
    commitHash: "0a99f19ab2936a2623fd03479ed4c4e22fedbdfa",
};
